<template>
  <div class="slot-box" ref="root">
    <div class="net-work-row flex-layout" style="align-items: center">
      <div
        class="net-work-port"
        v-for="(item, index) in list.filter(data => !((data.value % 2) == 0))"
        :key="index"
      >
        <div class="port-item port-item-one" :style="calcStyle(item.portNum)">
          <el-popover
            placement="top"
            popper-class="sakura-child-port-popover"
            trigger="click"
            :disabled="!checkFanout(item.portNum)"
            @after-enter="() => initInfoHandle(item.portNum)"
            @show="() => fanoutChange(item.portNum)"
            @hide="fanoutChange()"
            :visible="popoverStates[item.portNum]"
          >
            <template #reference>
              <div @click="handlePortClick(item.portNum)" style="cursor: pointer; height: 100%;">
                <sakura-port-lan
                  @port-click="() => emit('port-click', item)"
                  @port-click-fanout="() => emit('port-click-fanout', item)"
                  @change="(num) => emit('change', num, item)"
                  :type="item.type"
                  :isEnabledTu="props.isEnabledTu && item.isEnabledTu"
                  :tu="item.tu"
                  @update:tu="val => item.tu = val"
                  :value="item.selected"
                  :port="item.portNum"
                  :popover="props.popover"
                  :isEnabled="props.isEnabled && item.isEnabled"
                  :status="item.status"
                  :borderStatus="item.borderStatus"
                  v-model="item.selected"
                  :hex="item.hex"
                  :mode="item.mode"
                  :detach="item.detach"
                  :lag="item.lag"
                  :priority="item.priority"
                  :vendor="item.detect"
                  :config="item.config"
                  :isFanout="checkFanout(item.portNum)"
                >
                  {{ item.value }}
                </sakura-port-lan>
              </div>
            </template>
            <sakura-child-panel
              :list="fanout.filter(obj => obj.rootPortNum === item.portNum)"
              :popover="popover"
              :value="value"
              :multiple="multiple"
              :isEnabled="isEnabled"
              :isEnabledTu="isEnabledTu"
              @change="onChildSelectChange"
            />
          </el-popover>
        </div>
      </div>
    </div>

    <!-- Second row: Odd indexed ports -->
    <div class="net-work-row flex-layout" style="align-items: center">
      <div
        class="net-work-port"
        v-for="(item, index) in list.filter(data => ((data.value % 2) == 0))"
        :key="index"
      >
        <div class="port-item port-item-one"  :style="calcStyle(item.portNum)">
          <el-popover
            placement="top"
            popper-class="sakura-child-port-popover"
            trigger="click"
            :disabled="!checkFanout(item.portNum)"
            @after-enter="() => initInfoHandle(item.portNum)"
            @show="() => fanoutChange(item.portNum)"
            @hide="() => fanoutChange()"
            :visible="popoverStates[item.portNum]"
          >
            <template #reference>
              <div @click="handlePortClick(item.portNum)" style="cursor: pointer; height: 100%;">
                <sakura-port-lan
                  @port-click="() => emit('port-click', item)"
                  @port-click-fanout="() => emit('port-click-fanout', item)"
                  @change="(num) => emit('change', num, item)"
                  :type="item.type"
                  :isEnabledTu="props.isEnabledTu && item.isEnabledTu"
                  :tu="item.tu"
                  @update:tu="val => item.tu = val"
                  :value="item.selected"
                  :port="item.portNum"
                  :popover="props.popover"
                  :isEnabled="props.isEnabled && item.isEnabled"
                  :status="item.status"
                  :borderStatus="item.borderStatus"
                  v-model="item.selected"
                  :hex="item.hex"
                  :mode="item.mode"
                  :detach="item.detach"
                  :lag="item.lag"
                  :priority="item.priority"
                  invert
                  :vendor="item.detect"
                  :config="item.config"
                  :isFanout="checkFanout(item.portNum)"
                >
                  {{ item.value }}
                </sakura-port-lan>
              </div>
            </template>
            <sakura-child-panel
              :list="fanout.filter(obj => obj.rootPortNum === item.portNum)"
              :popover="popover"
              :value="value"
              :multiple="multiple"
              :isEnabled="isEnabled"
              :isEnabledTu="isEnabledTu"
              @change="onChildSelectChange"
            />
          </el-popover>
        </div>
      </div>
    </div>
  </div>
</template>


<script setup>
import { inject, defineProps, defineEmits, reactive, ref, onMounted, onBeforeUnmount } from 'vue'
import sakuraPortLan from './sakura-port-lan'
import sakuraChildPanel from './sakura-child-panel.vue'

const root = ref(null)
// Props
const popoverStates = reactive({})
const props = defineProps({
  popover: {
    type: Boolean,
    default: false
  },
  value: {
    type: Array,
    default: () => []
  },
  multiple: {
    type: Boolean,
    default: true
  },
  isEnabled: {
    type: Boolean,
    default: true
  },
  isEnabledTu: {
    type: Boolean,
    default: false
  },
  list: {
    type: Array,
    default: () => []
  },
  fanout: {
    type: Array,
    default: () => []
  }
})

// Inject
// const network = inject('network', null)
const injectedNetwork = inject('network', { fanoutNum: null })
const network =  reactive({
  ...injectedNetwork
})
const emit = defineEmits(['change', 'port-click', 'port-click-fanout'])

// Methods
  function isBlurred(portNum) {
    // If any popover is open and it's not the current port → blur this one
    const openPort = Object.keys(popoverStates).find(key => popoverStates[key]);
    return openPort && parseInt(openPort) !== portNum;
  }
  function handlePortClick(portNum) {
    for (const key in popoverStates) {
      popoverStates[key] = false
    }
    if (!checkFanout(portNum)) {
      network.fanoutNum = null
      return
    } 
    popoverStates[portNum] = true
    network.fanoutNum = portNum
  }
  function onChildSelectChange(num, obj) {
    emit('change', num, obj)
    popoverStates[network.fanoutNum] = true
  }
  
  function calcStyle(num) {
    const obj = {}
    if (network?.fanoutNum && network.fanoutNum !== num) {
      obj['filter'] = 'blur(3px)'
      obj['pointer-events'] = 'none'
    } 
    return obj
  }

  function checkFanout(port) {
    return !!(props.fanout && props.fanout.length && 
              props.fanout.find(item => item.rootPortNum === port));
  }

  function fanoutChange(num) {
    if (network) {
      network.fanoutNum = num ?? null
    } 
  }

function initInfoHandle(portNum) {
  // Placeholder
}
function nodeInPathMatches(path, selector) {
  if (!path) return false;
  for (const node of path) {
    if (!node || node.nodeType !== 1) continue;
    try {
      if (node.matches(selector)) return true;
    } catch { /* ignore invalid node types */ }
  }
  return false;
}

function handleGlobalClick(e) {
  const target = e.target;
  const path = (e.composedPath && e.composedPath()) || (function buildPath(n) {
    const p = [];
    while (n) { p.push(n); n = n.parentNode; }
    return p;
  })(target);

  if (nodeInPathMatches(path, '.el-select, .el-select__trigger, .el-select__popper, .el-select-dropdown, .el-select .el-input')) {
    return;
  }

  if (nodeInPathMatches(path, '.manual_trunk_select-popper, .profile_select-popper')) {
    return;
  }

  if (nodeInPathMatches(path, '.sakura-child-port-popover')) {
    return;
  }

  if (nodeInPathMatches(path, '.sakura-port-panel, .page-network-container, .slot-body, .slot-box')) {
    if (network) {
      network.fanoutNum = null;
    } 
    return;
  }

  if (nodeInPathMatches(path, '.sakura-port-popover')) {
    if (network) network.fanoutNum = null;
    return;
  }

  if (root.value && root.value.contains(target)) {
    return;
  }

  for (const k in popoverStates) popoverStates[k] = false;
  if (network) network.fanoutNum = null;
}
onMounted(() => {
  document.addEventListener("click", handleGlobalClick)
})
onBeforeUnmount(() => {
  document.removeEventListener("click", handleGlobalClick)
})
</script>

<style lang="scss" scoped>
@use "@/css/base.scss" as *;

.net-work-row {
  height: 50px;
}

.net-work-port {
  flex: 1;
  height: inherit;
  min-width: 50px;

  .port-item {
    height: 100%;
    line-height: 50px;
    text-align: center;
    position: relative;
  }

  .port-item-one {
    border-right: 1px solid $network-border-color;
    border-bottom: 1px solid $network-border-color;
  }

  .port-item-two {
    border-right: 1px solid $network-border-color;
  }

  .port-item .port-item-one:last-child,
  .port-item .port-item-two:last-child {
    border-right: none;
  }
  .blurred {
  filter: blur(3px);
  pointer-events: none;
  }
  ::v-deep(.el-popper) { 
    min-width: 150px !important;
  }
  
}
:deep(.el-popper.is-light.sakura-port-popover),
:deep(.el-popper.is-light.sakura-port-popover > .el-popper__arrow:before) {
  background: transparent !important;
}
</style>
